import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-arrow-right",
  "use": "circle-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 15a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-1a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm.497-3.703L9 10.292 11 8H4.5S4 8 4 7.5s.5-.5.5-.5H11L9 4.707c-.004 0-.354-.353 0-.707s.707 0 .707 0L13 7.5 9.708 11s-.354.354-.708 0c-.33-.33-.04-.66-.003-.703z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol